<template>
  <div  style="position: absolute;left: 0; top: 0; background-color: #f3f3f3; z-index: 1500;">
    <div class="d-flex align-items-center justify-content-center" id="cont_main">
      <div class="wraper col-md-8">
        <div class="logo-wraper ">
            <div class="logo d-flex align-items-center justify-content-center ">
              <img style="max-width: 30%; min-width: 30%;" src="../assets/pictures/me_big.png" alt="branding logo" @click="$router.push({ name: 'login'});">
            </div>
        </div>        
        <div class="form-wraper d-flex align-items-center justify-content-center" >
          <div class="form-content col-md-8">
              <div>
                <div class="lang-swicher">
                  <ul class="nav navbar-nav float-xs-right"> 
                    <li class="dropdown dropdown-language nav-item">
                    <a id="dropdown-flag" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="dropdown-toggle nav-link">
                      <!-- <i ref="lang_btn" class="flag-icon" :class="$i18n.tc('lang.logo', $i18n.locale )"></i> -->
                      <span class="selected-language"> {{$i18n.tc('lang.titleS', $i18n.locale )}}</span>
                    </a>                
                    <div aria-labelledby="dropdown-flag" class="dropdown-menu">
                      <a class="dropdown-item" @click="changeLanguage('ua')">UA </a>
                      <a class="dropdown-item" @click="changeLanguage('pl')">Pl</a>
                      <a class="dropdown-item" @click="changeLanguage('en')">EN </a>                  
                      <a class="dropdown-item" @click="changeLanguage('ru')">RU</a>
                      
                    </div>
                  </li>
                  </ul>
                </div>

                <div class="title my-2">
                  <h3>{{$t('login.lbl.login')}}</h3>
                </div>


              </div>
              
              <div class="login-form ">
                <login-form></login-form>
              </div>
              <div class="register mb-3 d-flex justify-content-end"> 
                  <div class="forgot-passwrd mr-2"><a href="/recover-password" @click.prevent="$router.push({name: 'recoveryPaasword'})">{{ $t('titles.forgotPasswrd') }}</a></div>                
                  <button type="button" class="btn btn-outline-secondary btn-md" @click.prevent="$router.push({name: 'register'})">{{ $t('login.lbl.register') }}</button>
                </div>            
          </div>          
        </div>
      </div>   
    </div>
  </div>
</template>

<script>
import loginForm from '../components/forms/login'
    export default {
      name: "LoginNew",
      components: {loginForm},
      data() {
          return { 
            role:"",     
            image: {name: null, data: null},
            errors: [],            
            submitStatus:null,
            
          }
        },
    
        methods: {
              
        },
        computed:{
                     },
        watch:{},
        mounted () {
       
        }
    }
</script>

<style scoped>

.img_cont{
  max-width: 40%;
}
  #cont_main{
  background-image: url('../assets/pictures/bagr.jpg');
  background-color: rgba(255,255,255,0.5); 
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
  width: 100vw;
  min-height: 100vh;
}

.form-wraper {
  background: #E5E5DB;
  width: 100%;  
}
.form-wraper .title {
  text-align: center;
}
.title h3 {
  font-weight: bold;
  font-size: 48px;
}
.selected-language {
    padding: 5px 5px;
    border: 1px solid #000;
}
.dropdown .dropdown-menu {
    min-width: 40px;
    background: #000;
    color: #fff;
}
.dropdown-item {
    color: #fff;
}
.dropdown-item:hover {
    color: #000;
}
a:not([href]):not([tabindex]):hover {
    color: #000;
}
.logo {
  margin-bottom: 40px;
   cursor: pointer;
}
.card-block {
  padding: 10px;
}
.form-control, .form-control-lg {
font-size: 1rem !important;
}
.btn-outline-secondary:hover {
  background-color: #000
}
.forgot-passwrd {
  padding-top: 5px;
}
@media only screen and (max-width: 800px) {
.inn {
   padding-left: 0px;
}
.ex-btn {
  display: block;
}
}
</style>


// WEBPACK FOOTER //
// src/pages/LoginNew.vue